import { render, staticRenderFns } from "./CMAttachmentsPage.vue?vue&type=template&id=270eac80&scoped=true&"
import script from "./CMAttachmentsPage.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsPage.vue?vue&type=style&index=0&id=270eac80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270eac80",
  null
  
)

export default component.exports